/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  function initBenefits(sectionId) {
    var $swiperEl = $('.js-benefits-swiper-' + sectionId);
    if (!$swiperEl.length) return;

    new Swiper($swiperEl[0], {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
    speed: 300,
    resistanceRatio: 0.85,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 3,
    followFinger: true,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false,
    nested: true,
    edgeSwipeDetection: true,
    edgeSwipeThreshold: 20,
    watchSlidesProgress: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.4,
      momentumVelocityRatio: 1,
      momentumBounce: false,
      sticky: false,
      minimumVelocity: 0.02,
    },
    cssMode: false,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
      navigation: {
        prevEl: '.js-benefits-prev-' + sectionId,
        nextEl: '.js-benefits-next-' + sectionId,
      },
      pagination: {
        el: '.js-benefits-pagination-' + sectionId,
        clickable: false,
      },
      breakpoints: {
        1279: { spaceBetween: 24 }
      },
      on: {
        init: function () {
          if ($(window).width() <= 800) return;
          var swiperEl = '.js-benefits-swiper-' + sectionId;

          ScrollReveal().reveal(swiperEl + ' .benefits-slider__slide', {
            origin: 'bottom',
            distance: '20px',
            duration: 700,
            delay: 0,
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            opacity: 0,
            scale: 1,
            once: true,
            interval: 40,
            afterReveal: function (el) {
              $(el).css({ visibility: '', opacity: '', transform: '' });
              ScrollReveal().clean(el);
            }
          });
        },
        slideChange: function () {
          if ($(window).width() <= 800) return;
          var swiper = this;
          $(swiper.slides).each(function (i, slide) {
            if ($(slide).css('opacity') === '0') {
              $(slide).css({
                transition: 'none',
                opacity: 1,
                transform: 'translateY(0)',
                visibility: 'visible'
              });
              ScrollReveal().clean(slide);
            }
          });
        }
      }
    });

    function openModal(index) {
      var $modal = $('#benefits-modal-' + sectionId + '-' + index);
      if (!$modal.length) return;

      if (window.lenis) window.lenis.stop();

      $modal.attr('aria-hidden', 'false').addClass('is-open');
      $modal.find('.benefits-modal__scroller').scrollTop(0);
    }

    function closeModal() {
      $('.benefits-modal.is-open').attr('aria-hidden', 'true').removeClass('is-open');

      if (window.lenis) window.lenis.start();
    }

    $swiperEl.on('click', '.benefits-slider__slide', function () {
      openModal(parseInt($(this).data('index'), 10));
    });

    $(document).on('click', '.benefits-modal__close', function () {
      closeModal();
    });

    $(document).on('click', '.benefits-modal__scroller', function (e) {
      if (e.target === this) closeModal();
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  if ($(window).width() > 800) {
    ScrollReveal().reveal('.benefits-slider', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
    ScrollReveal().reveal('.benefits-slider__nav', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 40,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }

  var instances = window.DeskBenefits || {};
  $.each(instances, function (id) {
    initBenefits(id);
  });
});